import { mapState, mapActions } from 'vuex'
import constants from '@/constant'

export default {
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    hasSlidePreviewTestInitialized() {
      return this.currentUser
      && this.currentUser.abTest
      && this.currentUser.abTest[constants.AB_TEST.SLIDE_TYPE_PREVIEW]
    },
  },
  watch: {
    'currentUser.id': {
      handler(value) {
        if (value !== undefined && !this.hasSlidePreviewTestInitialized) {
          this.handleABTestForSlideTypePreview()
        }
      },
    },
  },
  methods: {
    ...mapActions([
      'setupABTestNewSlideTypePreviewAction',
    ]),
    async handleABTestForSlideTypePreview() {
      if (this.hasSlidePreviewTestInitialized) {
        return
      }

      await this.setupABTestNewSlideTypePreviewAction()
    },
  },
}
